import { TARGET_AUDIENCE } from '../../constants';

const getMinimumPeak = (peakSheet: any, demographic: TARGET_AUDIENCE) => {
  const rowIndex = peakSheet.findIndex((row: any) => row[0] === demographic);

  if (rowIndex === -1) {
    throw new Error('Invalid row name');
  }

  const columnNames = peakSheet[0];
  const row = peakSheet[rowIndex];

  for (let i = 2; i < row.length; i++) {
    if (row[i] !== 'N/A') {
      return columnNames[i];
    }
  }
  return null;
};

export default getMinimumPeak;
